import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';

import { getLogoApp } from 'store/globalApp';

const MobileLogo = () => {
  const logoApp = useSelector(getLogoApp);

  if (!logoApp) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        height: '32px',
        width: 'auto',
        minWidth: '40px',
        maxWidth: '100px',
        overflow: 'hidden',
      }}
    >
      <img
        alt="Company Logo"
        src={logoApp}
        style={{
          maxHeight: '32px',
          maxWidth: '100px',
          width: 'auto',
          height: 'auto',
          objectFit: 'contain',
          objectPosition: 'right center',
          // Mantiene los colores originales del logo
          // Se adapta automáticamente a diferentes tamaños y proporciones
        }}
      />
    </Box>
  );
};

export default MobileLogo;
